<template>
  <section class="winever-card red">
    <div class="blue">
      <div class="yellow">
        <div class="dark-blue">
          <h1 class="title">{{ $t('component.winevercard.title') }}</h1>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.winever-card {
  @include media-desktop {
    grid-column: 1 / -1;
  }

  &.red {
    padding: token('size/space/gap/100') token('size/space/gap/200');
    border-radius: token('size/space/gap/100');
    background: token('color/red/600');
  }

  .blue {
    max-width: 31.25rem;
    margin: 0 auto;
    padding: token('size/space/gap/100') token('size/space/gap/200');
    border-radius: token('size/space/gap/050');
    background: token('color/blue/500');
  }

  .yellow {
    max-width: 22.25rem;
    margin: 0 auto;
    padding: token('size/space/gap/100') token('size/space/gap/200');
    border-radius: token('size/space/gap/050');
    background: token('color/yellow/700');
  }

  .dark-blue {
    max-width: 17.25rem;
    margin: 0 auto;
    padding: token('size/space/gap/050') token('size/space/gap/200');
    border-radius: token('size/space/gap/050');
    background-color: token('color/blue/950');
  }

  .title {
    width: 100%;
    max-width: 14.5rem;
    height: 1.625rem;
    margin: 0 auto;
    background: url('./assets/winever-text.svg') center no-repeat;
    background-size: contain;
    text-indent: -9999px;
  }
}
</style>
